import React, { useEffect, useState } from 'react'
import TopHeader from './top-header'
import NavItem from './nav-item'
import NavDropdown from './nav-dropdown'
import AppLogo from './app-logo'
import ChartIcon from 'icon/chart'
import HomeIcon from 'icon/home'
import NewsFeedIcon from 'icon/news'
import SpeakerIcon from 'icon/speaker'
import ContactIcon from 'icon/contact'
import SettingIcon from 'icon/setting'
import Offericon from 'icon/offerIcon'
import LocationIcon from 'icon/locationicon'
import WebhookIcon from 'icon/webhookicon'
import WalletIcon from 'icon/walleticon'
import Docs from 'icon/docs'
import ScanIcon from 'icon/scanIcon'
import MarketIcon from 'icon/marketIcon'
import BusinessIcon from 'icon/businessicon'
import BrandIcon from 'icon/brandicon'
import AccountIcon from 'icon/accounticon'
import PasssetupIcon from 'icon/passsetupicon'
import InfoIcon from 'icon/infoicon'
import TeamIcon from 'icon/teamicon'
import LinksIcon from 'icon/linksicon'
import RebrandingIcon from 'icon/rebrangingicon'
import IntegrationIcon from 'icon/integrationicon'
import BillIcon from 'icon/billicon'
import TicketIcon from 'icon/ticketIcon'
import { useAgency } from 'context/agency'
import { PREMIUM_APPS } from 'enums'
import ChatIcon from 'icon/chatIcon'
import GraphIcon from 'icon/graph'
import DocIcon from 'icon/docIcon'
import KeyIcon2 from 'icon/key'
import SnapshotIcon from 'icon/snapshot'
import SupportIcon from 'icon/supporticon'
import UserIcon from 'icon/usersIcon'
import ButtonGradient from 'component/Buttons/dashboard-btn'
import SideNAvButtonGradient from 'component/Buttons/sidenav-btn'
import BarChartIcon from 'icon/barchart'
import Detail from 'icon/detail'
import { useAuth } from 'context/auth'
import { useSSO } from 'context/sso'
import { FormikProvider } from 'formik'
import ClickOutSide from 'hooks/click-outside'

const premiumAppsNavItem = {
  [PREMIUM_APPS.chat]: {
    label: 'Chat',
    path: '/chat',
    icon: <ChatIcon />,
  },
  [PREMIUM_APPS.ticket]: {
    label: 'Ticket',
    path: '/ticket',
    icon: <TicketIcon />,
  },
  [PREMIUM_APPS.docs]: {
    label: 'Docs',
    path: '/docs',
    icon: <DocIcon />,
  },
  [PREMIUM_APPS.citypass]: {
    label: 'City Pass',
    icon: <SpeakerIcon />,
    children: [
      {
        label: 'Pass Setup',
        path: '/city-pass/pass-setup',
        icon: <PasssetupIcon />,
      },
      {
        label: 'Default Deal Setup',
        path: '/city-pass/deal-setup',
        icon: <SettingIcon />,
      },
      {
        label: 'Contact',
        path: '/cityPass-contact',
        icon: <ContactIcon />,
      },
    ],
  },
}

const menu = [
  {
    label: 'Home',
    path: '/home',
    icon: <HomeIcon />,
  },
  {
    label: 'Dashboard',
    path: '/dashboard',
    icon: <GraphIcon />,
  },
  {
    label: 'Newsfeed',
    path: '/news',
    icon: <NewsFeedIcon />,
  },
  {
    label: 'Accounts',
    icon: <AccountIcon />,
    children: [
      {
        label: 'Business',
        path: '/business',
        icon: <BusinessIcon />,
      },
      {
        label: 'Brand',
        path: '/brand',
        icon: <BrandIcon />,
      },
      {
        label: 'Location',
        path: '/location',
        icon: <LocationIcon />,
      },
      {
        label: 'Users',
        path: '/locationsusers',
        icon: <UserIcon />,
      },
    ],
  },
  {
    label: 'Configurator',
    icon: <SettingIcon />,
    children: [
      {
        label: 'Location App',
        path: '/locationConfig',
        icon: <LocationIcon />,
      },
      {
        label: 'Scan App',
        path: '/scannerConfig',
        icon: <ScanIcon />,
      },
    ],
  },
  {
    label: 'Wallet App',
    icon: <WalletIcon />,
    children: [
      {
        label: 'Branding',
        path: '/wallet-branding',
        icon: <RebrandingIcon />,
      },
      {
        label: 'Contact',
        path: '/wallet-contact',
        icon: <ContactIcon />,
      },
    ],
  },
  {
    label: 'Webhook',
    path: '/webhook',
    icon: <WebhookIcon />,
  },
  {
    label: 'Marketplace',
    path: '/market',
    icon: <MarketIcon />,
  },
  {
    label: 'Support',
    path: '/support',
    icon: <SupportIcon />,
  },
  {
    label: 'Snapshot',
    path: '/wc-snapshot',
    icon: <SnapshotIcon />,
  },

  {
    label: 'CRM Details',
    path: '/crmdetails',
    icon: <Detail />,
  },
]

const settings = [
  {
    label: 'Basicinfo',
    path: '/settings/info',
    icon: <InfoIcon />,
  },
  // {
  //   label: 'Team',
  //   path: '/settings/team',
  //   icon: <TeamIcon />,
  // },
  {
    label: 'ApiKey',
    path: '/settings/apikey',
    icon: <KeyIcon2 />,
  },
  {
    label: 'Links',
    path: '/settings/links',
    icon: <LinksIcon />,
  },
  {
    label: 'Rebranding',
    path: '/settings/rebranding',
    icon: <RebrandingIcon />,
  },
]

function Topbar() {
  const { premiumApps, styles } = useAgency()
  const [openSideMenu, setOpenSideMenu] = useState(false)
  const { auth } = useAuth()
  const { sso } = useSSO()
  const [showSettings, setShowSettings] = useState(
    window.location.pathname.includes('settings')
  )
  const [moreOpen, setMoreOpen] = useState(false)
  const [premiumOpen, setPremiumOpen] = useState(false)
  const [openSubmenu, setOpenSubmenu] = useState(null) // Track which submenu is open
  const sidenav_bg_color = styles.sidenav_bg_color
  const page_color = styles.page_bg_color
  const s_text_color = styles.sidenav_text_color

  const itemsToShow = (showSettings ? settings : menu).slice(0, 6)
  const remainingItems = (showSettings ? settings : menu).slice(6)

  if (!sso) {
    // If SSO is enabled, filter out items that are not allowed for the user
    const configItems = menu.find((item) => item.label === 'Configurator')

    configItems.children.push({
      label: 'Growthtool',
      path: '/growthtool',
      icon: <ChartIcon />,
    })

    menu.push([
      {
        label: 'SaaS Configurator',
        path: '/sassconfigurator',
        icon: <BarChartIcon />,
      },
    ])

    settings.push([
      {
        label: 'Snapshot',
        path: '/settings/snapshot',
        icon: <SnapshotIcon />,
      },
      {
        label: 'Billing',
        path: '/settings/billing',
        icon: <BillIcon />,
      },
      {
        label: 'Integration',
        path: '/settings/integration',
        icon: <IntegrationIcon />,
      },
    ])
  }

  const isAppExist = (app) => {
    return premiumApps.find((item) => item.upsale_id?.products?.includes(app))
  }

  const getPremiumApps = () => {
    const apps = []
    if (isAppExist(PREMIUM_APPS.citypass))
      apps.push(premiumAppsNavItem[PREMIUM_APPS.citypass])
    if (isAppExist(PREMIUM_APPS.chat))
      apps.push(premiumAppsNavItem[PREMIUM_APPS.chat])
    if (isAppExist(PREMIUM_APPS.ticket))
      apps.push(premiumAppsNavItem[PREMIUM_APPS.ticket])
    if (isAppExist(PREMIUM_APPS.docs))
      apps.push(premiumAppsNavItem[PREMIUM_APPS.docs])
    return apps
  }

  // const getPremiumApps = () => [
  //   {
  //     label: 'CityPass',
  //     path: '/citypass',
  //     children: [
  //       { label: 'CityPass Overview', path: '/citypass-overview' },
  //       { label: 'CityPass Benefits', path: '/citypass-benefits' },
  //     ],
  //   },
  //   {
  //     label: 'Chat',
  //     path: '/chat',
  //     children: [],
  //   },
  //   {
  //     label: 'Ticket',
  //     path: '/ticket',
  //     children: [
  //       { label: 'Ticket Booking', path: '/ticket/booking' },
  //       { label: 'Ticket Support', path: '/ticket/support' },
  //     ],
  //   },
  //   {
  //     label: 'Docs',
  //     path: '/docs',
  //     children: [],
  //   },
  // ];

  const renderItem = (menu_item, index) => {
    const hasChildren = menu_item.children && menu_item.children.length > 0

    return !sso ? (
      <li key={menu_item.label} className='relative group'>
        {hasChildren ? (
          <div className='px-4 py-2 hover:bg-gray-100 cursor-pointer flex justify-between items-center'>
            <div className='flex items-center'>
              {menu_item.icon && <span className='mr-2'>{menu_item.icon}</span>}
              <span>{menu_item.label}</span>
            </div>
            <svg
              className='w-4 h-4 transform group-hover:rotate-180 transition-transform duration-200'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M19 9l-7 7-7-7'
              />
            </svg>
          </div>
        ) : (
          <NavItem
            {...menu_item}
            active={window.location.pathname === menu_item.path}
          />
        )}
        {hasChildren && (
          <ul className='ml-4 bg-white border border-gray-200 rounded shadow-lg z-50 absolute hidden group-hover:block'>
            {menu_item.children.map((child) => (
              <li key={child.label} className='px-4 py-2 hover:bg-gray-100'>
                <NavItem
                  {...child}
                  active={window.location.pathname === child.path}
                />
              </li>
            ))}
          </ul>
        )}
      </li>
    ) : (
      <div key={menu_item.label}>
        {menu_item.children ? (
          <NavDropdown {...menu_item} />
        ) : (
          <NavItem
            {...menu_item}
            active={window.location.pathname === menu_item.path}
          />
        )}
      </div>
    )
  }

  //  const renderItem = (menu_item) => (
  //   <div key={menu_item.label}>
  //     {menu_item.children ? (
  //       <NavDropdown {...menu_item} />
  //     ) : (
  //       <NavItem
  //         {...menu_item}
  //         active={window.location.pathname === menu_item.path}
  //       />
  //     )}
  //   </div>
  // )
  return (
    <div>
      <nav
        style={{ backgroundColor: page_color }}
        className='fixed top-0 z-50 w-full bg-white border-b border-gray-200'
      >
        <div className='px-3 py-3 lg:px-5 lg:pl-3'>
          <div className='flex items-center'>
            {sso ? (
              <>
                <div className='flex items-center justify-between w-full'>
                  <nav
                    style={{ backgroundColor: sidenav_bg_color }}
                    className='flex items-center space-x-2 px-2 w-1/3 relative'
                  >
                    <ul className='flex space-x-2 font-medium text-md items-center'>
                      {/* Standard menu items (first 6) */}
                      {itemsToShow
                        .filter((menu_item) => menu_item.label !== 'Rebranding')
                        .map((menu_item) => (
                          <li
                            key={menu_item.label}
                            className='relative space-x-2'
                          >
                            {menu_item.children ? (
                              <NavDropdown {...menu_item} />
                            ) : (
                              <NavItem
                                {...menu_item}
                                active={
                                  window.location.pathname === menu_item.path
                                }
                              />
                            )}
                          </li>
                        ))}

                      {/* Premium dropdown BEFORE More */}
                      {!showSettings && getPremiumApps().length > 0 && (
                        <li
                          className='relative cursor-pointer '
                          onClick={() => setPremiumOpen(!premiumOpen)}
                        >
                          {/* <div
                      className="relative cursor-pointer"
                      onClick={() => setPremiumOpen(!premiumOpen)}
                    > */}
                          <p style={{ color: s_text_color }}>Premium</p>
                          {premiumOpen && (
                            <ul className='absolute left-0 w-48 bg-white border border-gray-200 rounded shadow-lg z-50'>
                              {getPremiumApps().map((menu_item, index) =>
                                renderItem(menu_item, index)
                              )}
                            </ul>
                          )}
                          {/* </div> */}
                        </li>
                      )}

                      {/* More dropdown */}
                      {remainingItems.length > 0 && (
                        <li className='relative'>
                          <div
                            className='relative cursor-pointer items-center'
                            onClick={() => setMoreOpen(!moreOpen)}
                          >
                            <span className='text-md bold'>...</span>
                            {moreOpen && (
                              <ul className='absolute left-0 mt-2 w-48 bg-white border border-gray-200 rounded shadow-lg z-50'>
                                {remainingItems.map((menu_item) => (
                                  <li
                                    key={menu_item.label}
                                    className='relative'
                                  >
                                    {menu_item.children ? (
                                      <NavDropdown {...menu_item} />
                                    ) : (
                                      <NavItem
                                        {...menu_item}
                                        active={
                                          window.location.pathname ===
                                          menu_item.path
                                        }
                                      />
                                    )}
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                        </li>
                      )}
                    </ul>
                  </nav>
                  <div className='flex items-center space-x-2'>
                    {showSettings ? (
                      <SideNAvButtonGradient
                        type='button'
                        onClick={() => setShowSettings(false)}
                        className='px-2 py-1 text-sm'
                      >
                        Go Back
                      </SideNAvButtonGradient>
                    ) : null}
                    {!showSettings && (
                      <SideNAvButtonGradient
                        type='button'
                        onClick={() => setShowSettings(true)}
                        className='px-2 py-1 text-sm'
                      >
                        Settings
                      </SideNAvButtonGradient>
                    )}
                    <TopHeader />
                  </div>
                </div>
              </>
            ) : (
              <div className='flex items-center justify-between w-full'>
                <AppLogo onToggle={() => setOpenSideMenu(!openSideMenu)} />
                <div className='flex items-center'>
                  <TopHeader />
                </div>
              </div>
            )}
          </div>
        </div>
      </nav>
      {!sso && (
        <aside
          style={{ backgroundColor: sidenav_bg_color }}
          className={`fixed top-0 left-0 z-40 w-64 h-screen pt-20 transition-transform bg-white border-r border-gray-200 sm:translate-x-0 ${
            openSideMenu ? 'transform-none' : '-translate-x-full'
          }`}
        >
          <div
            style={{ backgroundColor: sidenav_bg_color }}
            className='px-3 pb-4 overflow-y-auto h-[calc(100vh-140px)] bg-white'
          >
            {showSettings && (
              <div>
                <SideNAvButtonGradient
                  type='button'
                  onClick={() => setShowSettings(false)}
                  className='w-full pb-2 mb-4'
                >
                  Go Back
                </SideNAvButtonGradient>
              </div>
            )}
            <ul className='space-y-2 font-medium'>
              {(showSettings ? settings : menu).map((menu_item, index) =>
                renderItem(menu_item, index)
              )}
              {!showSettings && getPremiumApps().length > 0 && (
                <>
                  <hr />
                  <div className='text-md' style={{ color: s_text_color }}>
                    Premium
                  </div>
                  {getPremiumApps().map((menu_item, index) =>
                    renderItem(menu_item, index)
                  )}
                </>
              )}
            </ul>
            {!showSettings && (
              <div className='absolute bottom-0 w-full px-4 -ml-3 mb-3'>
                <SideNAvButtonGradient
                  type='button'
                  onClick={() => setShowSettings(true)}
                  className='w-full pb-2'
                >
                  Settings
                </SideNAvButtonGradient>
              </div>
            )}
          </div>
        </aside>
      )}
    </div>
  )
}

export default Topbar
